import React, {useContext, useEffect, useState} from 'react';
import {axiosInstance} from "../utils/axiosUtils";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Customers from "./Customers";
import BusinessContext from "../contexts/BusinessContext";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";

export function Home() {
    const {setShowTestMode, setTestNumber, setTestMode, shouldUpdateBusinessSettings, setShouldUpdateBusinessSettings, setAllowUpdateTestMode} = useContext(BusinessContext);
    const [customersToSync, setCustomersToSync] = useState([]);
    const [customersToDelete, setCustomersToDelete] = useState([]);
    const [tabName, setTabName] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [overridePhoneNumber, setOverridePhoneNumber] = useState();
    /*const [data, setData] = useState([]);*/
    const [disableSyncButton, setDisableSyncButton] = useState(false);
    const [customersData, setCustomersData] = useState([]);
    const [businessData, setBusinessData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const intervalId = setInterval(() => {
            refresh();
        }, 60000); //30000 - 30 seconds, 60000 - 1 minute, 600000 - 10 minutes
        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
        setLoading(true);
        try {
            axiosInstance.get('/Whatsapp/templates').then((response) => {
                response.data.data.unshift({name: "לא ידוע" ,  id:0})
                setBusinessData({...businessData, templates: response.data});
            });
            axiosInstance.get('/Whatsapp').then((response) => {
                const customers = response.data.map((item, index) => {
                    item.customer.index = index;
                    return item;
                });
                setCustomersData(customers);
                setLoading(false);
            });
        } catch (e) {
            setCustomersData([]);
            setLoading(false);
        }
    }, []);
    const syncCustomers = async () => {
        setDisableSyncButton(true);
        const response =  await axiosInstance.get('/Whatsapp/sync');
        const customers = response.data.map((item, index) => {
            item.customer.index = index;
            return item;
        });
        setLoading(true);
        setCustomersData(customers);
        setLoading(false);
        setDisableSyncButton(false);
    }
    useEffect(()=>{
        axiosInstance.get('/Business').then((response) => {
            setBusinessData({...businessData, settings: response.data});
            setShowTestMode(true);
            setTestNumber(response.data.testNumber);
            setTestMode(response.data.testMode);
            setAllowUpdateTestMode(response.data.allowUpdateTestMode);
        });
    },[shouldUpdateBusinessSettings])
    const refresh = () => {
        axiosInstance.get('/Whatsapp/refresh').then((response) => {
            if (response.data){
                if (response.data.changedCustomers && response.data.changedCustomers.length > 0) {
                    setCustomersToSync(response.data.changedCustomers);
                }
                if (response.data.deletedCustomers && response.data.deletedCustomers.length > 0) {
                    setCustomersToDelete(response.data.deletedCustomers);
                }
            }
        }).catch((e) => {
            console.log(e);
        });
    };
    const handleChange = (event, newTabName) => {
        setTabName(newTabName);
    };
    const updateCustomersData = (customerData) => {
        const newCustomersData = customersData.map(item => {
            // Check if the item matches the one you want to update
            if (item.customer.id === customerData.customer.id) {
                // Update the item
                return customerData;
            } else {
                // Keep the item unchanged
                return item;
            }
        });
        setCustomersData(newCustomersData);
    }
    return (
        <div>
            <div style={{display: 'flex', margin: '0 auto', maxWidth: '600px'}}
                 className='my-4 flex items-center justify-center'>
                <Box sx={{width: '100%'}}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs value={tabName} onChange={handleChange} aria-label="basic tabs example">
                            <Tab sx={{color: 'white'}} label="הודעות לשליחה"/>
                            <Tab sx={{color: 'white'}} label="הודעות שעבר זמנן "/>
                            <Tab sx={{color: 'white'}} label="לקוחות עם מידע חסר"/>
                            <Tab sx={{color: 'white'}} label="הודעות שנשלחו"/>
                        </Tabs>
                        {/*<Button disabled={disableSyncButton} onClick={syncCustomers} variant="contained">סנכרן לקוחות חדשים</Button>*/}
                        {loading && <Box sx={{marginTop: 30, marginBottom: 50}}><CircularProgress/></Box>}
                    </Box>
                    {!loading && <Box sx={{maxWidth: '460px', margin: "auto"}}>
                        <div
                            role="tabpanel"
                            hidden={tabName !== 0}
                            id={`simple-tabpanel-0`}
                            aria-labelledby={`simple-tab-0`}
                        >
                            <Customers updateCustomersData={updateCustomersData} overridePhoneNumber
                                       customersData={customersData} customersToDelete={customersToDelete} customersToSync={customersToSync}
                                       withMessageLog
                                       templates={businessData.templates ? businessData.templates : {data: []}}/>
                        </div>
                        <div
                            role="tabpanel"
                            hidden={tabName !== 1}
                            id={`simple-tabpanel-1`}
                            aria-labelledby={`simple-tab-1`}
                        >
                            <Customers updateCustomersData={updateCustomersData} overridePhoneNumber
                                       customersData={customersData} customersToDelete={customersToDelete} customersToSync={customersToSync}
                                       expired withMessageLog templates={businessData.templates}/>
                        </div>
                        <div
                            role="tabpanel"
                            hidden={tabName !== 2}
                            id={`simple-tabpanel-2`}
                            aria-labelledby={`simple-tab-2`}
                        >
                            <Customers updateCustomersData={updateCustomersData} overridePhoneNumber
                                       customersData={customersData} customersToDelete={customersToDelete}
                                       customersToSync={customersToSync} templates={businessData.templates}/>
                        </div>
                        <div
                            role="tabpanel"
                            hidden={tabName !== 3}
                            id={`simple-tabpanel-3`}
                            aria-labelledby={`simple-tab-3`}
                        >
                            <Customers updateCustomersData={updateCustomersData}
                                       overridePhoneNumber={overridePhoneNumber} inProcess
                                       customersData={customersData}
                                       customersToDelete={customersToDelete}
                                       customersToSync={customersToSync}
                                       withMessageLog templates={businessData.templates}/>
                        </div>
                    </Box>}
                </Box>
            </div>
            <Dialog
                open={showSettings}
                onClose={() => setShowSettings(false)}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        const phoneNumber = formJson.phoneNumber;
                        console.log(phoneNumber);
                        setOverridePhoneNumber(phoneNumber)
                        setShowSettings(false);
                    },
                }}
            >
                <DialogTitle>Subscribe</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        על מנת לערוך את הטלפון יש להזין את המספר החדש
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="phoneNumber"
                        name="phoneNumber"
                        label="מספר טלפון"
                        type="phoneNumber"
                        fullWidth
                        variant="standard"
                        value={overridePhoneNumber}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowSettings(false)}>ביטול</Button>
                    <Button type="submit">שמור</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

